<template>
  <div>
    <ChartBox :title="title">
      <div v-if="!suppList.length > 0">
        <img
          style="height: 232px; width: 100%"
          src="./../assets/image/NoImg.png"
          alt=""
        />
      </div>
      <el-carousel
        class="right-ul"
        height="230px"
        indicator-position="none"
        v-else
      >
        <el-carousel-item v-for="(item, index) in suppList" :key="index">
          <div
            class="right-li"
          >
            <el-image
              class="img"
              :src="item"
              :preview-src-list="suppList"
              style="width: 100%; height: 230px"
              fit="contain"
            ></el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
    </ChartBox>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
import { getFoodImgs } from "../api/api";
import { baseImgUrl } from "../utils/request";

export default {
  data() {
    return {
      suppList: [], //顾客建议
      cleanUpMemory: null,
      title: '食安公示'
    };
  },
  components: {
    ChartBox,
  },
  mounted() {
    this.getFoodImgs();
    this.cleanUpMemory = setInterval(() => {
      this.getFoodImgs();
    }, 15 * 60 * 1000);
  },
  methods: {
    // 获取供应商资质管理
    async getFoodImgs() {
      try {
        const res = await getFoodImgs();

        // 检查响应数据是否存在
        if (!res || !res.data || !res.data.data) {
          console.warn('食安图片数据响应格式不正确');
          return;
        }

        // 检查 imgs 是否存在且是数组
        if (res.data.data.imgs && Array.isArray(res.data.data.imgs)) {
          this.suppList = res.data.data.imgs;
        } else {
          this.suppList = [];
        }

        // 设置标题，确保存在
        this.title = res.data.data.title || '食安公示';
      } catch (error) {
        console.error('获取食安图片失败:', error);
        this.suppList = [];
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.cleanUpMemory);
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
